window.reactionDetailFormatter = function(value, row) {
    let html = '';
    if (row.motivation) {
        html += '<span class="fw-bold">'+__('Motivatie')+'</span>';
        html += '<p>'+row.motivation+'</p>';
    }
    if (row.comments) {
        html += '<span class="fw-bold">'+__('Opmerkingen')+'</span>';
        html += '<p>'+row.comments+'</p>';
    }
    return html;
};
